import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    getEmailThemePreview: configurationServices.getMerchantEmailThemePreview,
  },
  [configurationTypes.returnsPortal]: {
    getEmailThemePreview: configurationServices.getPortalEmailThemePreview,
  },
}
